"use strict";
exports.__esModule = true;
exports.MANUAL_PAY_FINISH = void 0;
exports.MANUAL_PAY_FINISH = {
    HEADER: 'Rent payment started!',
    BODY: 'You’ve successfully made your {{paymentType}} of {{amount}} and we’re in the process of submitting your rent payment to your property. Please allow up to 24 hours for the payment to be submitted.',
    CTA: 'Finish'
};
